import { useRouter } from 'next/router'
import React from 'react'
import { ROUTE } from 'shared-constants'
import { BUTTON_VARIANT, Button } from 'components/Button'
import { Delimiter } from 'components/Delimiter'
import { Flex } from 'components/Layout'
import { Modal } from 'components/Modal'
import { Text } from 'components/Typography'
import { FONT_WEIGHT, MODAL_MAX_WIDTH, SPACE } from 'Theme'

interface RecommendExpertModalProps {
  isModalOpen: boolean
  onModalClose: () => void
  filters: {
    tags?: string[]
    price?: {
      from: number
      to: number
    }
    availability?: { from: string; to: string }
    sessionLength?: number[]
  }
}

const RecommendExpertModal: React.FC<RecommendExpertModalProps> = ({
  isModalOpen,
  onModalClose,
  filters,
}) => {
  const router = useRouter()
  return (
    <Modal
      title="Request Availability"
      isWithFooter={false}
      isWithoutPaddings
      ariaLabel="Request Availability Modal"
      isOpen={isModalOpen}
      onModalClose={onModalClose}
      width="100%"
      maxWidth={MODAL_MAX_WIDTH.PX_720}
    >
      <Flex
        p={SPACE.PX_30}
        pt={SPACE.PX_20}
        flexDirection="column"
        width="100%"
      >
        <Text fontWeight={FONT_WEIGHT.MEDIUM} mb={SPACE.PX_24}>
          Your request has been received!
        </Text>
        <Text>
          Our team will review your details and get back to you as soon as
          possible. In the meantime, you can explore other available Experts.
        </Text>
        <Flex mt={SPACE.PX_30} />
        <Delimiter />
        <Flex mt={SPACE.PX_10} justifyContent="flex-end">
          <Button
            variant={BUTTON_VARIANT.OUTLINE}
            width="initial"
            onClick={onModalClose}
            mt={SPACE.PX_20}
          >
            Cancel
          </Button>
          <Flex ml={SPACE.PX_10} />
          <Button
            onClick={() => {
              const queryParams: {
                sessionLength?: number[]
                priceFrom?: number
                availabilityFrom?: string
                availabilityTo?: string
                priceTo?: number
                tags?: string[]
              } = {}
              if (filters.sessionLength) {
                queryParams.sessionLength = filters.sessionLength
              }
              if (filters.tags) {
                queryParams.tags = filters.tags
              }
              if (filters.price) {
                queryParams.priceFrom = filters.price.from
                queryParams.priceTo = filters.price.to
              }
              if (filters.availability) {
                queryParams.availabilityFrom = filters.availability.from
                queryParams.availabilityTo = filters.availability.to
              }
              router.push(ROUTE.EXPERTS(queryParams))
            }}
            width="initial"
            type="submit"
            mt={SPACE.PX_20}
          >
            Find available Experts
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default RecommendExpertModal
